import { render, staticRenderFns } from "./BundleCard.vue?vue&type=template&id=f907a324&scoped=true"
import script from "./BundleCard.vue?vue&type=script&lang=js"
export * from "./BundleCard.vue?vue&type=script&lang=js"
import style0 from "./BundleCard.vue?vue&type=style&index=0&id=f907a324&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f907a324",
  null
  
)

export default component.exports